import { createColumnHelper } from "@tanstack/react-table";
import { formatDateTime, formatPrice } from "../../../utils/format";
import { indexer } from "../../../utils/utils";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchHospitalDownload,
  useHospitalList,
} from "../../../api/member-management/use-hostpital";
import Modal from "../../../components/ui/Modal/Modal";
import Table from "../../../components/ui/Table/Table";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.email, {
      header: "아이디(이메일주소)",
      cell: (info) => {
        const val = info.getValue();
        const email = val?.length > 25 ? val?.substring(0, 25) + "..." : val;

        return <div>{val ? email : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.name, {
      header: "병원명",
      cell: (info) => {
        const val = info.getValue();
        const name = val?.length > 10 ? val?.substring(0, 10) + "..." : val;

        return <div>{val ? name : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.membersQnt, {
      header: "소속 직원수",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "0"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.patientsQnt, {
      header: "등록 환자수",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ?? "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.address, {
      header: "주소",
      cell: (info) => {
        const val = info.getValue();
        const address = val?.length > 15 ? val?.substring(0, 15) + "..." : val;

        return <div>{val ? address : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.contact, {
      header: "전화번호",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.paidPrice, {
      header: "총 결제금액",
      cell: (info) => {
        const val = info.getValue() ?? 0;
        return <div>{formatPrice(val)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "가입일시",
      cell: (info) => {
        const val = info.getValue();
        const date = formatDateTime(val);
        // const date = convertSecondsToDate(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.lastOrderedAt, {
      header: "마지막 주문일시",
      cell: (info) => {
        const val = info.getValue();
        const date = formatDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "관리",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`/hospital/${id}/detail`)}
      className="w-8 p-[1px] mx-2 border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function HospitalTable(props) {
  const { filter } = props;
  const { isEmpty, getDataTableProps } = useHospitalList(filter);
  const [tableData, setTableData] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(
    getDataTableProps().pagination?.pageIndex + 1
  );
  const [pageSize, setPageSize] = React.useState(
    getDataTableProps().pagination?.pageSize
  );
  const [totalData, setTotalData] = React.useState(
    getDataTableProps().totalAll
  );
  const [pageCount, setPageCount] = React.useState(
    getDataTableProps().pageCount
  );
  const [isEmptyResult, setIsEmptyResult] = React.useState(false);
  const onSave = async () => {
    await fetchHospitalDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `hospital-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  React.useEffect(() => {
    if (isEmpty) {
      setIsEmptyResult(true);
    } else {
      setIsEmptyResult(false);
    }
  }, [isEmpty, filter]);

  React.useEffect(() => {
    if (!isEmpty) {
      setTableData(getDataTableProps()?.data);
      setCurrentPage(getDataTableProps()?.pagination?.pageIndex + 1);
      setPageSize(getDataTableProps().pagination?.pageSize);
      setTotalData(getDataTableProps().total);
      setPageCount(getDataTableProps().pageCount);
    }
  }, [getDataTableProps()]);

  return (
    <>
      <Table
        {...getDataTableProps()}
        onSave={onSave}
        hasPageSizeFilter={false}
        hasSort={false}
        columns={columns(currentPage, pageSize, totalData)}
        data={tableData}
        pageCount={pageCount}
      />
      {isEmptyResult && (
        <Modal
          isOpenFromOutside={isEmptyResult}
          setIsOpenFromOutside={setIsEmptyResult}
          description="검색결과가 없습니다."
          hasCancel={false}
        />
      )}
    </>
  );
}
